import type { FC } from 'react'
import type { Rundown } from '@rundown-studio/types'
import formatTimezone from '../../utils/formatTimezone.js'
import formatTimeOfDay from '../../utils/formatTimeOfDay.js'
import { useAtomValue } from 'jotai'
import { getNowAtom } from '../../store/runner.store.js'
import { useCountdown } from '@/shared/lib/use-countdown'

type CurrentTimeOfDayProps = {
  timezone?: string
  omitSeconds?: boolean
  showTimezone?: boolean
  todDisplayFormat?: Rundown['settings']['todDisplayFormat']
}

export const CurrentTimeOfDay: FC<CurrentTimeOfDayProps> = ({
  timezone,
  omitSeconds = false,
  showTimezone = false,
  todDisplayFormat,
}) => {
  const getNow = useAtomValue(getNowAtom)

  useCountdown()

  const formattedTod = formatTimeOfDay(getNow(), {
    timezone,
    seconds: omitSeconds ? 'never' : 'always',
    format: todDisplayFormat,
  })

  if (timezone && showTimezone)
    return `${formattedTod} (${formatTimezone(timezone, 'abbr')})`

  return formattedTod
}
